"use client";

import Autoplay from "embla-carousel-autoplay";

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { useEffect, useState } from "react";
import clsx from "clsx";
import ImageOverlay from "@/components/image-overlay";

export interface FacilityThumbnailProps {
  facility_thumbnail: {
    id: string;
    label: string;
    image: string;
  }[];
}

export default function FacilityThumbnail(props: FacilityThumbnailProps) {
  const [api, setApi] = useState<CarouselApi>();

  const [activeCarousel, setActiveCarousel] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    setActiveCarousel(api.selectedScrollSnap());

    const onChangeIndexSlide = () => {
      setActiveCarousel(api.selectedScrollSnap());
    };

    api.on("select", onChangeIndexSlide);

    api.on("slidesInView", onChangeIndexSlide);

    return () => {
      api.off("select", onChangeIndexSlide);
      api.off("slidesInView", onChangeIndexSlide);
    };
  }, [api]);

  return (
    <Carousel
      className="xl:mb-8"
      setApi={setApi}
      opts={{ loop: true }}
      plugins={[
        Autoplay({
          delay: 5000,
        }),
      ]}
    >
      <CarouselContent>
        {props.facility_thumbnail.map((facility) => {
          return (
            <CarouselItem key={facility.id} className="pl-0">
              <div className="relative group">
                <ImageOverlay
                  src={facility.image}
                  className="object-cover w-full xl:h-[calc(100vh-var(--navbar-height))]"
                  alt=""
                  loading="lazy"
                />

                <div className="absolute top-1/2 z-[2] block xl:hidden">
                  <div className="inline-flex items-center">
                    <hr className="w-24 xl:w-52 border border-white" />
                    <span className="text-white text-[12px] xl:text-4xl ml-5 font-pluto">
                      {facility.label}
                    </span>
                  </div>
                </div>

                <div className="absolute bottom-8 left-1/2 xl:left-32 -translate-x-1/2 xl:translate-x-0 hidden xl:block">
                  <p className="font-semibold text-white text-[8px] xl:text-2xl">
                    {props.facility_thumbnail[activeCarousel].label}
                  </p>
                </div>
              </div>
            </CarouselItem>
          );
        })}
      </CarouselContent>

      <div className="inline-flex absolute bottom-12 xl:bottom-8 left-1/2 -translate-x-1/2 z-10 space-x-0.5 xl:space-x-2">
        {props.facility_thumbnail.map((_, index) => {
          return (
            <button
              key={index}
              onClick={() => api?.scrollTo(index, true)}
              className={clsx(
                "w-[3px] xl:w-4 h-[3px] xl:h-4 bg-white rounded-full",
                {
                  "!w-3 xl:!w-12": activeCarousel === index,
                }
              )}
            ></button>
          );
        })}
      </div>
    </Carousel>
  );
}
